import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X, Plus, Trash2, FlaskConical } from 'lucide-react';
import { uid } from '../lib/model';
import { useAgents, saveAgents, getAgents } from '../lib/agents';

export const openAgents = () => window.dispatchEvent(new Event('giss-agents-open'));
const FIELDS = [['name', 'text'], ['reg', 'text'], ['ingredient', 'text'], ['wait', 'num'], ['rate', 'num']];

function Row({ t, a, i }) {
  const upd = (p) => saveAgents(getAgents().map((x) => (x.id === a.id ? { ...x, ...p } : x)));
  return (
    <div className="ag-row" data-testid={`agent-row-${i}`}>
      <select data-testid={`agent-kind-${i}`} value={a.kind} onChange={(e) => upd({ kind: e.target.value })}>
        <option value="spray">🧪 {t.agSpray}</option><option value="fert">🌿 {t.agFert}</option>
      </select>
      {FIELDS.map(([f, ty]) => (
        <label key={f}>{t['ag_' + f]}{f === 'rate' ? ` (${a.kind === 'fert' ? 'kg/ha' : 'l/ha'})` : ''}
          <input data-testid={`agent-${f}-${i}`} inputMode={ty === 'num' ? 'decimal' : 'text'} value={a[f] || ''} onChange={(e) => upd({ [f]: e.target.value })} />
        </label>
      ))}
      <button className="icon-btn" data-testid={`agent-del-${i}`} onClick={() => window.confirm(t.agDelQ) && saveAgents(getAgents().filter((x) => x.id !== a.id))}><Trash2 size={15} /></button>
    </div>
  );
}

// plant-protection & fertiliser database (name, registration no., active ingredient, waiting period, default rate)
export default function AgentDb({ t }) {
  const [open, setOpen] = useState(false);
  const list = useAgents();
  useEffect(() => { const on = () => setOpen(true); window.addEventListener('giss-agents-open', on); return () => window.removeEventListener('giss-agents-open', on); }, []);
  if (!open) return null;
  const add = () => saveAgents([...getAgents(), { id: uid('ag'), kind: 'spray', name: '', reg: '', ingredient: '', wait: '', rate: '' }]);
  return createPortal(
    <div className="editor-backdrop" data-testid="agent-db-dialog" onClick={(e) => e.target === e.currentTarget && setOpen(false)}>
      <div className="editor ag-ed">
        <div className="row pf-head"><h4><FlaskConical size={18} /> {t.agTitle}</h4><button className="icon-btn" data-testid="agent-db-close-btn" onClick={() => setOpen(false)}><X size={18} /></button></div>
        <small className="muted">{t.agHint}</small>
        {!list.length && <p className="muted" data-testid="agent-db-empty">{t.agEmpty}</p>}
        <div className="ag-list">{list.map((a, i) => <Row key={a.id} t={t} a={a} i={i} />)}</div>
        <button className="btn btn-green" data-testid="agent-add-btn" onClick={add}><Plus size={16} /> {t.agAdd}</button>
      </div>
    </div>,
    document.body,
  );
}
